import React from 'react';
import PropTypes from 'prop-types';

const FiltersHead = ({ categoryName, count, label }) => (
  <div className='bra-subHead'>
    <div className='bra-subHeadline__wrapper'>
      <h1 className='bra-subHeadline'>{categoryName}</h1>
    </div>
    <p className='bra-subHead__text'>
      <strong>{count}</strong> {label}
    </p>
  </div>
);

FiltersHead.propTypes = {
  categoryName: PropTypes.string,
  count: PropTypes.number,
  label: PropTypes.string,
};

FiltersHead.defaultProps = {
  categoryName: '...',
  count: 0,
  label: '...',
};

export default FiltersHead;
